import type React from 'react';
import Input from 'app/shared/core/Input';
import numberUtils from 'app/shared/utils/numberUtils';

type InputPhoneNumberProps = {
  onChange?: (e: React.ChangeEvent<HTMLInputElement>) => void;
  value?: string;
} & Omit<React.ComponentProps<typeof Input>, 'onChange' | 'value' | 'type'>;

const InputPhoneNumber: React.FC<InputPhoneNumberProps> = ({ onChange, value, ...rest }) => {
  const handleTextInput = (e: React.ChangeEvent<HTMLInputElement>) => {
    e.target.value = numberUtils.cleanPhoneNumber(e.target.value);
    if (onChange) {
      onChange(e);
    }
  };

  return <Input {...rest} onChange={handleTextInput} type="tel" value={numberUtils.formatPhoneNumber(value)} />;
};

InputPhoneNumber.displayName = 'InputPhoneNumber';

export default InputPhoneNumber;
